<template>
    <div>
        <el-dialog
                title="找回密码"
                :visible.sync="dialog_visible"
                width="30%">
            <label class="image-replace cd-password">请输入账户名</label>
            <el-input v-model="input" placeholder="请输入内容"></el-input>
            <span slot="footer" class="dialog-footer">
    <el-button @click="go_back">取 消</el-button>
    <el-button id="button" type="primary" @click="get_password">返回密码</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "forget",
    data() {
        return {
            dialog_visible: true,
            input: '',
            flag: ''
        }
    },
    methods: {
        clear_data() {
            this.input = ''
        },
        go_back() {
            this.clear_data()
            this.dialog_visible = false
            this.$router.push('/login');
        },
        get_password() {
            if (this.input === '') {
                this.flag = '1'
                this.$message.error('账户不能为空');
                return
            }
            this.$axios({
                // url: this.IBMS_API + '/',
                url: 'https://mockapi.eolink.com/nlBXn4C3b7255774e2d611c30b0da8665ae9ffa5d69bf6e/forget',
                method: 'post',
                data: {
                    "version": "版本",
                    "timestamp": "时间戳",
                    "data": {
                        "user_name": this.input
                    }
                }
            }).then((response) => {
                if (response.data.result === 200) {
                    this.flag = response.data.content.password
                    this.$alert(response.data.content.password, '密码：', {
                        confirmButtonText: '确定',
                    })
                } else if (response.data.result === 1001) {
                    this.flag = '3'
                    this.$message.error('账户不存在');
                } else {
                    this.flag = '4'
                    this.$message.error('失败请重试');
                }
            }).catch(() => {
                this.flag = '5'
            })
        }
    }
}
</script>

<style scoped>

</style>